import { reducer as referralReducer } from './referral.slice';

export default referralReducer;
